// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6b7W7","field":"styles_field__2gxoK","fieldCol":"styles_fieldCol__1YxCX","diffCol":"styles_diffCol__1CqKz","diff":"styles_diff__2RgdY"};